exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table .current-row td{\n  background-color: #f5f7fa !important;\n}\n", ""]);

// exports
